import { Clear as ClearIcon, KeyboardArrowDown } from '@mui/icons-material';
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from '@mui/material';
import { FieldConfig } from 'model/deals.model';
import zeplinColor from 'theme/Color';

const SelectField = ({
  field,
  value,
  options,
  onChange,
  onBlur,
  isXs,
}: {
  field: FieldConfig;
  value: any;
  options: any[];
  onChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(
      field: T,
    ): T extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
  };
  onBlur: {
    (e: React.FocusEvent<any>): void;
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
  };
  isXs: boolean;
}) => {
  const { name, label, required } = field;

  return (
    <FormControl fullWidth>
      <InputLabel
        size={isXs ? 'small' : 'medium'}
        required={required}
        sx={{ '& .MuiFormLabel-asterisk': { color: zeplinColor.Error } }}
      >
        {label}
      </InputLabel>
      <Select
        name={name}
        value={(typeof value === 'object' ? value.dealTypeId : value) || ''}
        label={label}
        onChange={(e: SelectChangeEvent) => {
          if (name === 'dealType') {
            const target = options.find((opt) => opt.id === e.target.value);
            onChange({
              target: {
                name: name,
                value: {
                  dealTypeId: target.id,
                  dealTypeName: target.name,
                  dealTypeKey: target.key,
                },
              },
            });
          } else {
            onChange(e);
          }
        }}
        onBlur={onBlur}
        IconComponent={KeyboardArrowDown}
        size={isXs ? 'small' : 'medium'}
        endAdornment={
          value && (
            <IconButton
              size='small'
              sx={{ marginRight: 2 }}
              onClick={(e) => {
                e.stopPropagation();
                onChange({ target: { name, value: '' } });
              }}
            >
              <ClearIcon fontSize='small' />
            </IconButton>
          )
        }
      >
        {options.map((opt: { id: string; name: string; key?: string } | string) => {
          const isObject = typeof opt === 'object' && opt !== null;
          const itemValue = isObject ? opt.id : opt;
          const itemLabel = isObject ? opt.name : opt;

          return (
            <MenuItem key={String(itemValue)} value={itemValue}>
              <Typography variant='responsiveBody2'>{itemLabel}</Typography>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default SelectField;
